import { useState } from "react";
import {ArtistGallery} from "./ArtistGallery";
import { UserGallery } from "./UserGallery";
export default function Tabs() {
  const [activeTab, setActiveTab] = useState("tab1");

  return (
    <div className="">
      {/* Tabs header */}
      <div className="flex px-1 gap-5">
        <button
          onClick={() => setActiveTab("tab1")}
          className={`relative px-1 pb-2 font-bold  text-sm font-grotesk
        ${activeTab === "tab1" ? "text-black" : "text-[#8A8F99]"}`}
        >
          By Artist
          {activeTab === "tab1" && (
            <span className="absolute bottom-0 left-0 w-full h-[2px] bg-primary"></span>
          )}
        </button>
        <button
          onClick={() => setActiveTab("tab2")}
          className={`relative px-1 pb-2 font-bold  text-sm font-grotesk
        ${activeTab === "tab2" ? "text-black" : "text-[#8A8F99]"}`}
        >
          By Users
          {activeTab === "tab2" && (
            <span className="absolute bottom-0 left-0 w-full h-[2px] bg-primary"></span>
          )}
        </button>
      </div>

      {/* Tabs content */}
      <div className="mt-5">
        {activeTab === "tab1" && <ArtistGallery/>}
        {activeTab === "tab2" && <UserGallery/>}
      </div>
    </div>
  );
}
